export interface DocumentFormat {
  content_type: string;
  extension: string;
  original: boolean;
  blob_name: string;
}

export interface WikiDocumentTags {
  category: string;
  domain: string;
  subdomain: string;
}

export type DocumentAuthority =
  | 'law'
  | 'statutory_code'
  | 'official_guidance'
  | 'industry_guidance'
  | 'informal_guidance'
  | 'learning_resource'
  | 'local_policy';

// Base document without wiki-specific fields.
// Fields marked optional are not returned by the /docs/list endpoint
// (WikiDocumentListItem) but may be present on full document detail responses.
export interface Document {
  id: string; // ULID
  base_document_id?: number;
  version_id?: number;
  title: string;
  title_normalised?: string;
  reference?: string;
  filestem?: string;
  status: 'draft' | 'active' | 'archived' | 'deleted';
  visibility: 'private' | 'tenant' | 'public';
  created_by: number | null;
  /** Whose Personal Folder this file currently lives in. Distinct from created_by. */
  personal_folder_user_id?: number | null;
  created_at: string; // ISO datetime string
  updated_at?: string; // ISO datetime string (not in list response; use modified_at)
  modified_at?: string; // ISO datetime string (returned by list endpoint)
  tenant: string;
  formats?: DocumentFormat[];
  summary: string | null;
  publication_date: string | null; // ISO date string
}

// WikiDocument extends Document with additional metadata
export interface WikiDocument extends Document {
  tags: WikiDocumentTags;
  public_url: string | null;
  jurisdiction?: string | null;
  authority?: DocumentAuthority | null;
  effective_from?: string | null;
  effective_to?: string | null;
}

// Type guard to check if a document is a WikiDocument
export function isWikiDocument(doc: Document | WikiDocument): doc is WikiDocument {
  return 'tags' in doc;
}
